import type { AgentTemplate } from '../data/templates';

interface AgentTemplateCardProps {
  template: AgentTemplate;
  onSelect?: (template: AgentTemplate) => void;
}

export default function AgentTemplateCard({ template, onSelect }: AgentTemplateCardProps) {
  return (
    <div
      className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 p-5 hover:shadow-md transition-shadow cursor-pointer group"
      onClick={() => onSelect?.(template)}
    >
      <div className="flex items-start justify-between mb-3">
        <div>
          <h3 className="font-semibold text-gray-800 dark:text-gray-100 group-hover:text-purple-600 dark:group-hover:text-purple-400 transition-colors">
            {template.name}
          </h3>
          <span className="text-xs px-2 py-0.5 rounded-full bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300 mt-1 inline-block">
            {template.category}
          </span>
        </div>
        <div className="flex -space-x-2">
          {template.agents.slice(0, 4).map((agent) => (
            <div
              key={agent.id}
              className="w-8 h-8 rounded-full border-2 border-white dark:border-gray-800 flex items-center justify-center text-white text-xs font-bold"
              style={{ backgroundColor: agent.color }}
              title={agent.name}
            >
              {agent.name.split(' ').map((w) => w[0]).join('')}
            </div>
          ))}
          {template.agents.length > 4 && (
            <div className="w-8 h-8 rounded-full border-2 border-white dark:border-gray-800 bg-gray-200 dark:bg-gray-600 flex items-center justify-center text-gray-600 dark:text-gray-300 text-xs font-bold">
              +{template.agents.length - 4}
            </div>
          )}
        </div>
      </div>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">{template.description}</p>

      <div className="flex items-center justify-between">
        <span className="text-xs text-gray-400 dark:text-gray-500">
          {template.agents.length} agents &middot; {template.connections.length} connections
        </span>
        <button className="text-sm px-3 py-1 bg-purple-600 text-white rounded-lg hover:bg-purple-700 opacity-0 group-hover:opacity-100 transition-opacity">
          Use Template
        </button>
      </div>
    </div>
  );
}
